<template>
  <div v-loading="loading" style="padding: 14px;">
    <el-row class="row-top" :gutter="24">
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone1.png" alt />
          <div>
            <h5 style="color:#374FB8;">{{detail.totalCallDuration||'--'}}</h5>
            <p>通话时长</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone2.png" alt />
          <div>
            <h5 style="color:#27D5DF;">{{detail.successCallNum||'--'}}</h5>
            <p>拨通数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone3.png" alt />
          <div>
            <h5 style="color:#FF414F;">{{detail.failCallNum||'--'}}</h5>
            <p>未通数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div>
          <img src="@/assets/call/phone4.png" alt />
          <div>
            <h5 style="color:#FFB85A;">{{detail.successCallRate||'--'}}</h5>
            <p>接通率</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="div-screen">
      <div class="div-row">
        <span class="span-lable">电话号码：</span>
        <el-input v-model="customerNumber" size="small" class="mr-20" style="width:200px;" @input="customerNumber=customerNumber.replace(/[^\d]/g,'')" @keyup.enter.native="handleCurrentChange(1)"
          @blur="handleCurrentChange(1)" placeholder="请输入电话号码"></el-input>
        <span class="span-lable">外呼员工：</span>
        <!-- <el-select v-model="userIds" placeholder="请选择外呼员工" size="small" filterable class="mr-20" multiple collapse-tags style="width:200px;" @change="handleCurrentChange(1)">
          <el-option v-for="(item,index) in customerEmpoyArr" :key="index" :label="item.accountName" :value="item.id"></el-option>
        </el-select> -->
        <el-cascader popper-class="cascader-department" ref="cascader" class="mr-20" size="small" style="width:200px;" filterable placeholder="请选择外呼员工" :options="options" :show-all-levels="false"
          :props="props" v-model="ownerValue" collapse-tags clearable @change="changeCascader"></el-cascader>
        <span class="span-lable">客户名称：</span>
        <el-select v-model="customerIds" placeholder="请选择客户名称" size="small" class="mr-20" style="width:200px;" :filter-method="filterMethod1" @change="handleCurrentChange(1)" multiple collapse-tags
          filterable>
          <el-option v-for="item in customerList" :key="item.value" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="div-row">
        <span class="span-lable">联系人：</span>
        <!-- <el-input v-model="customerNumber" size="small" class="mr-20" style="width:200px;" placeholder="请输入联系人名称"></el-input> -->
        <el-select v-model="contactIds" placeholder="请选择联系人" size="small" class="mr-20" style="width:200px;" :filter-method="filterMethod" @change="handleCurrentChange(1)" multiple collapse-tags
          filterable>
          <el-option v-for="item in contactList" :key="item.value" :label="item.name" :value="item.id" />
        </el-select>
        <span class="span-lable">来源：</span>
        <el-select v-model="source" placeholder="请选择来源" size="small" class="mr-20" style="width:200px;" @change="handleCurrentChange(1)">
          <el-option v-for="(item,i) in sourceLists" :key="i" :label="item.label" :value="item.value" />
        </el-select>
        <a @click="clickReset" class="a-btn"><img src="@/assets/call/icon-chongzhi.png" alt /> 重置</a>
      </div>
      <div class="div-row">
        <span class="span-lable">拨打时间：</span>
        <template></template>
        <span class="span-option" :class="item.value === callTime ? 'is-select' : ' '" v-for="(item,index) in timeOption" :key="index" @click="clickTime(item.value)">{{ item.label }}
        </span>
        <span class="span-option" :class="callTime === -1 ? 'is-select' : ' '" @click="clickTime(-1)" style="margin-right:0">自定义</span>
        <el-date-picker v-if="callTime=== -1" size="mini" style="width:250px;" v-model="date" @change="handleCurrentChange(1)" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="ml-20" />
      </div>
      <div class="div-row">
        <span class="span-lable">状态：</span>
        <span class="span-option" :class="item.value === status ? 'is-select' : ' '" v-for="(item,index) in statusOptions" :key="index" @click="clickState(item.value)">{{ item.label }}</span>
      </div>
    </div>
    <div class="div-table">
      <p class="p-title mt-10 mb-20">呼叫明细
        <span class="fr">
          <el-button size="mini" type="primary" @click="exportCallRecord">导出</el-button>
        </span>
      </p>
      <el-table :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{color:'#333'}">
        <el-table-column align="center" type="selection" width="60"></el-table-column>
        <el-table-column label="客户名称" show-overflow-tooltip>
          <template #default="scope">{{scope.row.callOutName||'--'}}</template>
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" show-overflow-tooltip>
          <template #default="scope">{{scope.row.contactName||'--'}}</template>
        </el-table-column>
        <el-table-column prop="customerNumber" label="手机号码" width="110"></el-table-column>
        <el-table-column prop="ownerName" label="归属人" min-width="120" show-overflow-tooltip>
          <template #default="scope">{{scope.row.ownerName||'--'}}</template>
        </el-table-column>
        <el-table-column prop="userName" label="外呼员工" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="callTime" label="拨打时间" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="拨打状态" width="120">
          <template #default="scope">
            <play-status v-if="scope.row.status==3" type="success">已接通</play-status>
            <play-status v-else type="error">未接通</play-status>
          </template>
        </el-table-column>
        <el-table-column prop="bridgeDurationFormat" label="通话时长" min-width="80"></el-table-column>
        <el-table-column prop="previewOutcallLeftClid" label="客户侧外显" min-width="110">
          <template #default="scope">{{scope.row.previewOutcallLeftClid||'--'}}</template>
        </el-table-column>
        <el-table-column prop="source" label="来源">
          <template #default="scope">{{scope.row.source>0?sourceList[scope.row.source] : '--'}}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template #default="scope">
            <el-button v-if="scope.row.status==3" type="text" @click="showRecord(scope.row)">聊天录音</el-button>
            <!-- <el-button v-if="scope.row.source==10" type="text" @click="clickDetail(scope.row)">详情</el-button> -->
            <!-- <el-button v-if="scope.row.source!=5&&scope.row.source!=10" type="text" @click="showDetail(scope.row)">详情</el-button> -->
            <!-- <el-button v-if="scope.row.source==5" type="text" @click="clickTracking(scope.row)">通话追踪</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total" :pageNum="pageNum" :pageSize="pageSize" :total="total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange"></pagination>
    </div>

    <el-dialog title="聊天录音" :visible.sync="dialogVisible" width="720px" :before-close="handleCloseDialog" class="audio-dialog">
      <el-row class="audio-wrap">
        <el-col :span="12">
          <p class="grayText">客户名称：<span class="darkText">{{currentRecord.callOutName||'--'}}</span></p>
          <p class="grayText">手机号码：<span class="darkText">{{currentRecord.customerNumber||'--'}}</span></p>
          <p class="grayText">拨打状态： <play-status v-if="currentRecord.status==3" type="success">已接通</play-status>
            <play-status v-else type="error">未接通</play-status>
          </p>
        </el-col>
        <el-col :span="12">
          <p class="grayText">联系人：<span class="darkText">{{currentRecord.contactName||'--'}}</span></p>
          <p class="grayText flex">归属人：
            <el-tooltip class="item" effect="dark" :content="currentRecord.ownerName" placement="top-end">
              <span class="darkText ellipsis">{{currentRecord.ownerName||'--'}}</span>
            </el-tooltip>
          </p>
          <p class="grayText">通话时长：<span style="color:#374FB8">{{currentRecord.bridgeDurationFormat}}</span></p>
        </el-col>
      </el-row>
      <audioPlay ref="audioPlay" :uniqueId="currentRecord.requestUniqueId" :key="currentRecord.requestUniqueId" />
    </el-dialog>
    <!-- 外呼 -->
    <!-- <callSocket ref="callSocket" :sourceType='5' @resetInterface="resetInterface" /> -->
    <!-- 名单详情 -->
    <detail ref="detail" @getData="loadData" :isAdmin="isAdmin" />
  </div>
</template>
<script>
// import { getDepartUserStructure } from '@/api/index'
// import Bus from '@/utils/bus'
import '@/assets/text/text.css'
import pagination from '@/components/pagination'
import audioPlay from '@/components/audioPlay'
import detail from '../component/detail'
import PlayStatus from '../component/PlayStatus'
import { getCallRecord, getCustomerNameByLike, getContactNameByLike, getCallRecordCount, exportCallRecord, tracking, isOptionUser, getDepartUserStructure } from '../api'

export default {
  components: { PlayStatus, detail, pagination, audioPlay },
  data () {
    return {
      isAdmin: false,
      ownerValue: [],
      props: { multiple: true, label: 'value', value: 'id', children: 'childList' },
      options: [], // type 类型 1：部门 2：员工
      customerNumber: '',
      source: '',
      sourceLists: [
        // { label: '全部', value: null },
        { label: '线索', value: 1 }, { label: '联系人', value: 2 }, { label: '客户', value: 3 }, { label: '其他', value: 5 }, { label: '名单', value: 10 }
      ],
      sourceList: ['--', '线索', '联系人', '客户', '商机', '其他', '', '', '', '', '名单'],
      customerIds: [],
      contactIds: [],
      callTime: 0, // 拨打时间段
      status: 0,
      date: [],
      tableData: [],
      currentRecord: {},
      multipleSelection: [],
      customerData: [],
      contactData: [],
      detail: {},
      timeOption: [{ label: '全部', value: 0 }, { label: '今日', value: 1 }, { label: '昨日', value: 2 },
        { label: '近7日', value: 3 }, { label: '近30天', value: 4 }, { label: '近半年', value: 6 }],
      statusOptions: [{ label: '全部', value: 0 }, { label: '已接通', value: 1 }, { label: '未接通', value: 2 }],
      dialogVisible: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,

      index: 1,
      queryStr: '',
      arr1: [],
      arr: [],
      userIds: [],
      customerEmpoyArr: [],
      contactList: [],
      customerList: []
    }
  },
  computed: {
    // customerData () {
    //   const { queryStr = '', customerData } = this
    //   if (queryStr) return customerData.filter(v => v.name.includes(queryStr)).slice(0, this.index * 20)
    //   return customerData.slice(0, this.index * 20)
    // },
    // contactList () {
    //   const { queryStr = '', contactData } = this
    //   if (queryStr) return contactData.filter(v => v.name.includes(queryStr)).slice(0, this.index * 20)
    //   return contactData.slice(0, this.index * 20)
    // }
  },
  watch: {
  },
  beforeDestroy () {
    this.$bus.$off('callOutCancel')
  },
  mounted () {
    this.$bus.$on('callOutCancel', () => {
      this.pageNum = 1
      this.loadData()
    })
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
    this.date = [start, end]
    isOptionUser().then(res => {
      this.isAdmin = res.data
    })
    this.init()
    this.loadData()
    this.getDepartUserStructure()
    // selectSubordinateUserList().then(res => {
    //   if (res.code == 0) {
    //     this.customerEmpoyArr = res.data
    //   }
    // })
    // if (this.$route.params.call == 1) {
    //   this.initCalling()
    // }
    // Bus.$on('initCalling', (val) => {
    //   this.initCalling()
    // })
  },
  updated () {
    this.fixCascader()
  },
  methods: {
    // clickCall (row) {
    //   var data = {
    //     customerNumber: row.customerNumber,
    //     contactName: row.contactName
    //   }
    //   this.$bus.$emit('callFixed', data)
    // },
    fixCascader () {
      const cascader = document.querySelectorAll('.el-cascader__search-input')
      for (let index = 0; index < cascader.length; index++) {
        cascader[index].setAttribute('placeholder', '')
      }
    },
    changeCascader () {
      this.userIds = []
      this.ownerValue.forEach(e => {
        this.userIds.push(e[e.length - 1])
      })
      this.pageNum = 1
      this.loadData()
    },
    getOptions (arr) {
      if (arr && arr.length) {
        arr.forEach(e => {
          this.$set(e, 'disabled', false)
          if (e.type == 2) {
            delete e.childList
          }
          if (e.type == 1 && (e.childList == undefined || e.childList == null || !e.childList || !e.childList.length || e.containFlag !== 1)) {
            e.disabled = true
          }
          if (e.childList && e.childList.length) {
            this.getOptions(e.childList)
          } else {
            delete e.childList
          }
        })
      }
    },
    getDepartUserStructure () {
      getDepartUserStructure().then(res => {
        this.options = res.data
        this.getOptions(this.options)
      }).catch(_ => { })
    },
    clickDetail (row) {
      var data = {
        id: row.leadId
      }
      if (row.leadId) {
        this.$refs.detail.openDrawer(data)
      }
    },
    initCalling () {
      this.$nextTick(() => {
        this.$refs.callSocket && this.$refs.callSocket.initCalling({})
      })
    },
    resetInterface () {
      this.loadData()
    },
    clickTracking (row) {
      tracking({ id: row.id }).then(res => {
        // 呼叫来源  1:线索 2：联系人 3：客户 4：商机
        if (res.data.source === 1) {
          this.$router.push({ path: '/customerManage/opportunities/clue/clueDetail', query: { id: res.data.id } })
        } else if (res.data.source === 2) {
          this.$router.push({ path: '/customerManage/customer/contacts/detail', query: { id: res.data.id } })
        } else if (res.data.source === 3) {
          this.$router.push({ path: '/customerManage/customer/list/customerDetailNew', query: { id: res.data.id } })
        } else if (res.data.source === 4) {
          this.$router.push({ path: '/customerManage/opportunities/businessOpp/viewDetail', query: { id: res.data.id } })
        } else if (res.data.source === 5) {
          this.$router.push({ path: '/customerManage/opportunities/clue/clueEdit', query: { customerNumber: row.customerNumber } })
        }
      })
    },
    init () {
      getCustomerNameByLike({}).then(res => {
        this.customerData = res.data
        this.customerList = res.data.slice(0, 100)
      })
      getContactNameByLike({}).then(res => {
        this.contactData = res.data
        this.contactList = res.data.slice(0, 100)
      })
    },
    loadmore () {
      this.index++
    },
    filterMethod1 (query) { // 客户
      // 获取选中的list
      this.customerData.forEach((val, i) => {
        this.customerIds.forEach(id => {
          if (val.id.indexOf(id) !== -1) {
            this.arr1.push(val)
            this.customerData.splice(i, 1)
          }
        })
      })
      this.arr1.forEach((e, i) => {
        var index = this.customerIds.indexOf(e.id)
        if (index === -1) {
          this.arr1.splice(i, 1)
        }
      })
      var idnex = (100 - this.arr1.length) // 默认选择100条减去选中的条数
      if (query === '') { // 合并选中的条数加上截取的list共计100条
        this.customerList = this.arr1.concat(this.customerData.slice(0, idnex))
      } else {
        const result = []
        this.customerData.forEach(val => {
          if (val.name.indexOf(query) !== -1) result.push(val)
        })
        this.customerList = this.arr1.concat(result.slice(0, idnex)) // 合并选中的条数加上截取的list共计100条
      }
    },
    filterMethod (query) { // 联系人
      // 获取选中的list
      this.contactData.forEach((val, i) => {
        this.contactIds.forEach(id => {
          if (val.id.indexOf(id) !== -1) {
            this.arr.push(val)
            this.contactData.splice(i, 1)
          }
        })
      })
      this.arr.forEach((e, i) => {
        var index = this.contactIds.indexOf(e.id)
        if (index === -1) {
          this.arr.splice(i, 1)
        }
      })
      var idnex = (100 - this.arr.length) // 默认选择100条减去选中的条数
      if (query === '') { // 合并选中的条数加上截取的list共计100条
        this.contactList = this.arr.concat(this.contactData.slice(0, idnex))
      } else {
        const result = []
        this.contactData.forEach(val => {
          if (val.name.indexOf(query) !== -1) result.push(val)
        })
        this.contactList = this.arr.concat(result.slice(0, idnex)) // 合并选中的条数加上截取的list共计100条
      }
    },
    visibleChange (type) {
      this.index = 1
    },
    async loadData () {
      const options = {
        customerNumber: this.customerNumber,
        userIds: this.userIds,
        source: this.source,
        callTime: this.callTime === -1 ? null : this.callTime,
        callBeginDate: this.callTime === -1 && this.date ? this.date[0] : '',
        callEndDate: this.callTime === -1 && this.date ? this.date[1] : '',
        status: this.status,
        contactIds: this.contactIds,
        customerIds: this.customerIds,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      try {
        const res = await getCallRecord(options)
        this.tableData = res.data.list
        this.total = Number(res.data.total)

        const res2 = await getCallRecordCount(options)
        this.detail = res2.data.list[0]

        this.loading = false
      } catch (error) {
        this.loading = false
      }
      // this.getCallRecord(options)
      // this.getCallRecordCount(options)
    },
    // getCallRecord(options) {
    //   this.loading = true
    //   getCallRecord(options).then(res => {
    //     console.log(res.data.list)
    //     this.tableData = res.data.list
    //     this.total = Number(res.data.total)
    //     this.loading = false
    //   }).catch(_ => { this.loading = false })
    // },
    // getCallRecordCount(options) {
    //   getCallRecordCount(options).then(res => {
    //     this.detail = res.data.list[0]
    //     this.loading = false
    //   }).catch(_ => { this.loading = false })
    // },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    clickState (val) {
      this.status = val
      this.handleCurrentChange(1)
    },
    clickTime (val) {
      this.callTime = val
      if (val === -1) {
        this.isCustom = true
      }
      this.handleCurrentChange(1)
    },
    clickReset () {
      this.ownerValue = []
      this.customerNumber = ''
      this.userIds = []
      this.source = ''
      this.pageNum = 1
      this.pageSize = 10
      this.status = 0
      this.callTime = 0
      this.customerIds = []
      this.contactIds = []
      this.init()
      this.handleCurrentChange(1)
    },
    showRecord (row) {
      this.dialogVisible = true
      this.currentRecord = row
    },
    showDetail (row) {
      // 呼叫来源  1:线索 2：联系人 3：客户 4：商机
      if (row.source === 1) {
        this.$router.push({ path: '/customerManage/opportunities/clue/clueDetail', query: { id: row.leadId } })
      } else if (row.source === 2) {
        this.$router.push({ path: '/customerManage/customer/contacts/detail', query: { id: row.contactId } })
      } else if (row.source === 3) {
        this.$router.push({ path: '/customerManage/customer/list/customerDetailNew', query: { id: row.customerId } })
      } else if (row.source === 4) {
        this.$router.push({ path: '/customerManage/opportunities/businessOpp/viewDetail', query: { id: row.businessId } })
      }
    },
    handleCloseDialog () {
      this.dialogVisible = false
      this.currentRecord = {}
      if (!this.$refs.audioPlay.isPaused) return
      this.$refs.audioPlay.playAudio()
    },
    exportCallRecord () {
      if (!this.tableData.length) {
        this.$message.warning('暂无可导出数据')
        return false
      }
      const options = {
        source: this.source,
        callTime: this.callTime === -1 ? null : this.callTime,
        callBeginDate: this.callTime === -1 && this.date ? this.date[0] : '',
        callEndDate: this.callTime === -1 && this.date ? this.date[1] : '',
        status: this.status,
        contactIds: this.contactIds,
        customerIds: this.customerIds,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ids: this.multipleSelection.length ? this.multipleSelection.map(item => item.id) : []
      }
      exportCallRecord(options).then(res => {
        this.Global.downloadBlob(res.data, '通话记录.xlsx')
      })
    },
    // 分页的
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange (i) {
      this.pageNum = i
      this.loadData()
    }

  },
  beforeDestroy () {
    this.$bus.$off('initCalling')
  }
}
</script>
<style lang="scss" scoped>
.row-top {
  .el-col-6 {
    > div {
      background: #fff;
      height: 116px;
      padding: 26px 24px;
      box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
      font-family: 'PTRootUI-Medium, PTRootUI';
      img {
        width: 64px;
        height: 64px;
        margin-right: 24px;
        position: relative;
        top: -10px;
      }
      div {
        display: inline-block;
        width: calc(100% - 88px);
        position: relative;
        top: 15px;
        h5 {
          position: relative;
          top: -15px;
          font-size: 28px;
          font-weight: bold;
        }
        p {
          position: relative;
          top: -5px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}
.div-screen {
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .div-row {
    // height: 32px;
    // line-height: 32px;
    position: relative;
    .el-cascader {
      height: 32px !important;
      /deep/ .el-input__inner {
        height: 32px !important;
      }
      /deep/.el-cascader__tags .el-tag {
        max-width: 45% !important;
      }
      /deep/ .el-cascader__tags .el-tag > span {
        flex: auto;
      }
      /deep/ .el-cascader-node__postfix {
        top: 50%;
        transform: translateY(-50%);
      }
      /deep/ .el-cascader__search-input {
        min-width: 40px !important;
      }
    }
    /deep/ .el-icon-close {
      right: -5px;
      top: 0;
    }
    /deep/ .el-select__tags .el-tag {
      max-width: 80px !important;
    }
    /deep/ .el-select .el-select__tags > span {
      display: contents !important;
    }
    /deep/ .el-select .el-select__tags > span .el-tag__close.el-icon-close {
      right: -1px;
      top: 3px;
    }
  }
  .div-row + .div-row {
    margin-top: 12px;
  }
  .span-lable {
    display: inline-block;
    text-align: right;
    width: 60px;
    color: #666;
    font-size: 12px;
    margin-right: 8px;
  }
  .el-select-v2 {
    position: relative;
    top: 1px;
  }
  .input-with-select /deep/ .el-input-group__append {
    width: 32px;
    background: #374fb8;
    padding: 0 10px;
    border-color: #374fb8;
  }
  .a-btn {
    position: relative;
    top: 1px;
    display: inline-block;
    width: 66px;
    height: 32px;
    border: 1px solid #e4e6e8;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    color: #666;
    font-size: 12px;
    img {
      position: relative;
      top: -1px;
    }
  }
  .span-option {
    font-size: 12px;
    color: #666;
    cursor: pointer;
    margin-right: 32px;
  }
  .span-option:hover {
    color: #374fb8;
  }
  .is-select {
    font-size: 14px;
    color: #374fb8;
  }
}
.w-160 {
  width: 160px;
}
.div-table {
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .p-title {
    border-left: 3px solid #02a7f0;
    padding-left: 5px;
  }
}
.audio-dialog {
  /deep/ .el-dialog__body {
    padding: 30px 24px;
    border-top: 1px solid #e5e5e5;
  }
  .audio-wrap {
    margin-bottom: 20px;
    p {
      padding: 10px 0;
      font-size: 12px;
    }
    span {
      font-size: 14px;
    }
    .ellipsis{
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex: 1;
      cursor: pointer;
    }
  }
}
.div-table {
  padding: 24px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(37, 53, 138, 0.1);
  .el-button--primary {
    background: #374fb8;
    border-color: #374fb8;
    padding: 8.5px 28px;
    margin-left: 24px;
    position: relative !important;
    top: -6px !important;
  }
  .p-title {
    color: #333;
    font-weight: 600;
    border-left: 2px solid #374fb8;
    padding-left: 5px;
    .el-button {
      position: relative;
      top: -5px;
    }
  }
}
</style>
